import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Group } from '@vx/group';
import { Line } from '@vx/shape';

const ImportantDates = ({ margin, dates, xScale, xMax, yMax }) => {
  if (dates.length === 0) {
    return null;
  }

  return (
    <Group
      top={margin.top}
      left={margin.left}
      style={{ pointerEvents: 'none' }}
    >
      {dates.map(({ startDate, endDate }) => {
        // Round the x coordinate for a nicer display.
        const xStart = Math.floor(xScale(startDate));
        const xEnd = Math.ceil(xScale(endDate));
        const isSingleDay =
          startDate.getFullYear() === endDate.getFullYear() &&
          startDate.getMonth() === endDate.getMonth() &&
          startDate.getDate() === endDate.getDate();
        // We know xStart <= xEnd. If xEnd is before the end of the
        // graph, or xStart is past the end, then it must mean the
        // date range is entirely invisible.
        if (xEnd < 0 || xStart > xMax) {
          return null;
        }

        return (
          <Fragment key={`${xStart}-${xEnd}`}>
            {!isSingleDay && xStart >= 0 && (
              <Line
                from={{ x: xStart, y: 0 }}
                to={{ x: xStart, y: yMax }}
                stroke="rgba(255, 212, 0, 0.5)"
                strokeWidth={1}
              />
            )}
            {!isSingleDay && xEnd <= xMax && (
              <Line
                from={{ x: xEnd, y: 0 }}
                to={{ x: xEnd, y: yMax }}
                stroke="rgba(255, 212, 0, 0.5)"
                strokeWidth={1}
              />
            )}
            <rect
              x={Math.max(xStart, 0)}
              y={0}
              width={Math.min(xEnd, xMax) - Math.max(xStart, 0)}
              height={yMax}
              fill={
                // Make single days more prominent
                isSingleDay
                  ? 'rgba(228, 182, 11, 0.75)'
                  : 'rgba(255, 212, 0, 0.25)'
              }
            />
          </Fragment>
        );
      })}
    </Group>
  );
};

const { number, func, shape, arrayOf, instanceOf } = PropTypes;

ImportantDates.propTypes = {
  margin: shape({
    top: number,
    left: number,
  }).isRequired,
  dates: arrayOf(
    shape({
      startDate: instanceOf(Date),
      endDate: instanceOf(Date),
    })
  ).isRequired,
  xScale: func.isRequired,
  xMax: number.isRequired,
  yMax: number.isRequired,
};

export default ImportantDates;
